import { BidParamSpec, MarketPlaceProperties } from './bidderCatalog'
import { PrebidModuleType } from './prebidModule'

export type CatalogItemType = 'prebidModule' | 'prebidBidder' | 'wrapper' | 'adServer' | 'otherModules' | 'prebidWrapper'

export const CATALOG_ITEM_TYPE: { [key in CatalogItemType]: string } = {
  prebidModule: 'Prebid module',
  prebidBidder: 'Prebid bidder',
  wrapper: 'Wrapper',
  adServer: 'Ad Server',
  otherModules: 'Other module',
  prebidWrapper: 'Prebid Wrapper',
} as const

export type Labels = {
  shortLabel: string
  longLabel: string
}
export const MODULE_TYPE_MAPPING: { [key in PrebidModuleType]: Labels } = {
  Identity: { longLabel: 'ID solution', shortLabel: 'Identity' },
  RTD: { longLabel: 'Real-Time Data (RTD)', shortLabel: 'Real-Time Data' },
  Analytics: { longLabel: 'Analytics', shortLabel: 'Analytics' },
  Rendering: { longLabel: 'Rendering', shortLabel: 'Rendering' },
}

/**
 * Generic object for catalog
 */
export type CatalogItem<T extends CatalogItemType = CatalogItemType> = {
  id: string
  displayName: string
  /** What the entry does, in one line — the card's own subtitle. Bidders carry theirs on `BidderCatalog`. */
  tagline?: string
  code: string
  isUsed: boolean
  moduleType?: PrebidModuleType
  marketplace?: MarketPlaceProperties
} & (T extends 'prebidBidder'
  ? {
      isServerSideCompatible?: boolean
      disableAliasing?: boolean
      type: 'prebidBidder'
      bidParams: BidParamSpec[]
      pbjsMinRequiredVersion?: string
      scopePbjsVersion?: string
      tfshapingBidder?: string
    }
  : T extends 'prebidModule'
    ? {
        type: 'prebidModule'
        pbjsMinRequiredVersion?: string
        scopePbjsVersion?: string
      }
    : { type: T })

/** GAM Ad Server */
export const GAM_AD_SERVER_ITEM: CatalogItem = {
  id: 'gam',
  displayName: 'Google Ad Manager (GAM)',
  code: 'gam',
  isUsed: true,
  type: 'adServer',
} as const

/** Prebid Wrapper */
export const PREBID_WRAPPER: CatalogItem = {
  id: 'prebid',
  displayName: 'Prebid',
  code: 'prebid',
  isUsed: true,
  type: 'wrapper',
} as const

/** TAM */
export const TAM_WRAPPER_ITEM: CatalogItem = {
  id: 'tam',
  displayName: 'Amazon TAM',
  code: 'tam',
  isUsed: true,
  type: 'wrapper',
}
